export class SupervisorGroupsRequestFindAll{
    pageSize: number;
    pageNumber: number;
    
}

export class SupervisorGroupsRequest{
    name: string;
    storeId: number;
    userId: number;
    
}

export class SupervisorGroupsRequestCreate extends SupervisorGroupsRequest{
    constructor(){super();}
}

export class SupervisorGroupsRequestUpdate{
    name: string;
}

export class SupervisorGroupsRequestStores{
    storeIds : number[];
}

export class SupervisorGroupsRequestUsers{
    userIds  : number[];
}

export class SupervisorRequestSearch{
    pageNumber: number;
    pageSize: number;
    sortBy: string;
    name: string;
    
}
